module.exports = __webpack_public_path__ + "static/media/download_white.ade2fd8e.svg";